export const MAX_PLUS_ONES_COUNT = 9

// Guest list orders starting with it list guests by last name
export const LAST_NAME_ORDER_PREFIX = "last_name"

export const MAX_FORMS_PER_EVENT = 25
export const EMAIL_VALIDATION_REGEX = /^(?:(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))|)$/i
export const EMAIL_USER_VALIDATION_REGEX = /^[a-zA-Z0-9._%+-]+$/

export const CHART_COLORS = ["#5DA5DA", "#FAA43A", "#60BD68", "#F17CB0", "#B2912F", "#B276B2", "#DECF3F", "#F15854"]

export enum DateFormat {
  MONTH_DAY_YEAR = "MMMM d, yyyy",
  DAY_OF_WEEK_MONTH_DAY = "EEEE, MMMM do",
  DAY_OF_WEEK_MONTH_DAY_YEAR = "EEEE, MMMM d, yyyy",
  MONTH_DAY_YEAR_AT_HOUR_MINUTE = "M/d/yyyy 'at' h:mm aaa"
}

export const SENDER_PHONE_NUMBER = "+1 646-921-4232"

export const LOW_SMS_CREDIT_THRESHOLD = 50

// The Portal's below-`md` layout, sized by the preview section (container), not the window.
export const PHONE_CONTAINER_QUERY = "@container (max-width: 767.98px)"
